<template>
  <div class="home_page">
    <el-container class="bigContainer">
      <!-- 侧边栏 -->
      <el-aside width="200px">
        <div class="side_img">
          <img src="../../assets/login/logo.png" alt="" />
        </div>
        <div class="side_nav">
          <el-row class="tac">
            <el-col :span="24">
              <!-- <h5>自定义颜色</h5> -->
              <el-menu
                :default-active="this.$route.path"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
                background-color="#303070"
                text-color="#fff"
                active-text-color="#fff"
                router
              >
                <!-- <router-link to="/Home/homeIndex"> -->
                  <el-menu-item index="/Home/homeIndex">
                    <i class="el-icon-monitor"></i>
                    <span slot="title">云管理</span>
                  </el-menu-item>
                <!-- </router-link> -->

                <!-- <router-link to="/Home/projectManagement"> -->
                  <el-menu-item index="/Home/projectManagement">
                    <i class="el-icon-s-management"></i>
                    <span slot="title">项目管理</span>
                  </el-menu-item>
                <!-- </router-link> -->

                <!-- <router-link to="/Home/agentManagement"> -->
                  <el-menu-item index="/Home/agentManagement">
                    <i class="el-icon-s-custom"></i>
                    <span slot="title">代理商管理</span>
                  </el-menu-item>
                <!-- </router-link> -->
                
                <!-- <router-link to="/Home/userManagement"> -->
                  <el-menu-item index="/Home/userManagement">
                    <i class="el-icon-user"></i>
                    <span slot="title">用户管理</span>
                  </el-menu-item>
                <!-- </router-link> -->

                <el-submenu index="1" v-if="cloudType !== 1">
                  <template slot="title">
                    <i class="el-icon-suitcase"></i>
                    <span>设备管理</span>
                  </template>
                  <el-menu-item index="/Home/equipmentLibrary">设备库</el-menu-item>
                  <!-- <el-menu-item index="/Home/modelManagement">模型管理</el-menu-item> -->
                  <!-- <el-menu-item index="/Home/addEquipment">模型管理</el-menu-item> -->
                  <!-- <el-menu-item index="/Home/equipmentModel">模型设备</el-menu-item> -->
                </el-submenu>
                <el-submenu index="1" v-if="cloudType === 1">
                  <template slot="title">
                    <i class="el-icon-suitcase"></i>
                    <span>设备管理</span>
                  </template>
                  <el-menu-item index="/Home/equipmentLibrary">设备库</el-menu-item>
                  <!-- <el-menu-item index="/Home/modelManagement">模型管理</el-menu-item> -->
                  <!-- <el-menu-item index="/Home/addEquipment">模型管理</el-menu-item> -->
                  <!-- <el-menu-item index="/Home/equipmentModel">模型设备</el-menu-item> -->
                </el-submenu>

                <el-submenu index="2">
                  <template slot="title">
                    <i class="el-icon-suitcase-1"></i>
                    <span>新设备库</span>
                  </template>
                  <el-menu-item index="/Home/module-sys">模块关联系统</el-menu-item>
                  <el-menu-item index="/Home/device-category">设备类型</el-menu-item>
                  <el-menu-item index="/Home/sys-manage">系统管理</el-menu-item>
                  <el-menu-item index="/Home/module-manage">模块管理</el-menu-item>
                  <el-menu-item index="/Home/device-manage">设备管理</el-menu-item>
                </el-submenu>
                <el-menu-item index="/Home/deviceRepositoryLanguage">
                    <i class="el-icon-set-up"></i>
                    <span slot="title">设备库语言</span>
                  </el-menu-item>
                <!-- <router-link to="/Home/firmwareUpdate"> -->
                  <el-menu-item index="/Home/firmwareUpdate">
                    <i class="el-icon-takeaway-box"></i>
                    <span slot="title">固件管理</span>
                  </el-menu-item>
                <!-- </router-link> -->
                  <el-menu-item index="/Home/packageManagement">
                    <i class="el-icon-s-shop"></i>
                    <span slot="title">套餐管理</span>
                  </el-menu-item>
                  <el-menu-item index="/Home/infraredCodeLibrary">
                    <i class="el-icon-shopping-bag-1"></i>
                    <span slot="title">红外码库</span>
                  </el-menu-item>
                <!-- <el-submenu index="2">
                  <template slot="title">
                    <i class="el-icon-setting"></i>
                    <span>设置</span>
                  </template>
                  <el-menu-item index="/Home/softwareUpgrade">软件升级</el-menu-item>
                </el-submenu> -->

              </el-menu>
            </el-col>
          </el-row>
        </div>
      </el-aside>
      <el-container class="smallContainer">
        <!-- 头部 -->
        <el-header>
          <div class="header">
            <!-- <div class="search">
              <el-autocomplete
                v-model="state"
                :fetch-suggestions="querySearchAsync"
                placeholder="Search"
                @select="handleSelect"
                prefix-icon="el-icon-search"
              ></el-autocomplete>
            </div> -->
            <svg-icon class="user" icon-class="eye" />
            <div class="userinfo">
              <el-avatar :size="50" :src="circleUrl"></el-avatar>
              <span class="user_name">{{userInfo.nickName}}</span>
              <!-- <span class="quit" @click="quit">退出</span> -->
              <span>
                <el-dropdown trigger='click' @command="handleCommand">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command='exit'>退出</el-dropdown-item>
                    <!-- <el-dropdown-item disabled>双皮奶</el-dropdown-item>
                    <el-dropdown-item divided>蚵仔煎</el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </div>
          </div>
        </el-header>
        <el-main>
          <div class="main">
            <!-- <div class="bread_cloud"> -->
              <!-- 面包屑 -->
              <!-- <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item 
                    :to="{path:item.path}"
                    v-for="item in crumb"
                    :key="item.id"
                    >{{item.name}}
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div> -->
              <!-- 下拉 -->
              <!-- <div class="cloudSelect">
                <el-select v-model="value" placeholder="请选择云服务"  :label-in-value="true" @change="cloudChange(value)">
                  <el-option
                    v-for="item in clouds"
                    :key="item.id"
                    :label="item.cloudName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div> -->
            <!-- </div> -->
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
// import children1 from './projectManagement/index'
 import Utils from '../../js/utils' 
//引入store中vuex中的user info
import {mapState} from "vuex"
import {cloudSelectInfo} from '@/api'
import {mapMutations} from "vuex"

export default {
  //引入store中vuex中的修改好的userinfo
  computed:{
    ...mapState(["userInfo"]),
    //传值映射面包屑
    ...mapState(['crumb']), 
  },
  
  data() {
    return {
      //搜索框
      companys: [],
      state: "",
      timeout: null,
      //选择的云管理
      clouds: [],
      value: null,
      cloudType: null,
      cloudId: null,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      page2: {
        pageNum: 1,
        pageSize: 5,
      },
      //头像
      circleUrl:
        "https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2369017631,3935728806&fm=26&gp=0.jpg",
    };
  },

  methods: {
    //赋值映射
    ...mapMutations(['SET_CLOUDID']),

    cloudSelect() {
      cloudSelectInfo().then((res) => {
        // console.log(res);
        this.clouds = res.data.data;
        // console.log(this.clouds[0].cloudName);
        // localStorage.setItem("cloudId",this.cloudId)
        // let cloudId = localStorage.getItem("cloudId")
        // this.SET_CLOUDID(cloudId)
        // console.log(cloudId);
        // this.value = this.clouds[0].cloudName
        // this.cloudId = this.clouds[0].id
        // console.log(this.cloudId);
        // this.SET_CLOUDID(this.cloudId)
        // Utils.$emit('demo',this.cloudId,this.page)
      });
    },
    //下拉选择信息
    cloudChange(event){
      this.$router.push('./homeIndex')
      this.value = event.cloudName
      this.cloudType = event.cloudType
      this.cloudId = event.id
      localStorage.setItem("cloudId",this.cloudId)
      let cloudId = JSON.parse(localStorage.getItem("cloudId"))
      this.SET_CLOUDID(cloudId)
      Utils.$emit('demo',cloudId,this.page)
      Utils.$emit('demo1',cloudId,this.page)
      Utils.$emit('demo2',cloudId,this.page2)
      Utils.$emit('demo3',cloudId,this.page)
      // this.$refs.child1.updateProjectTable(this.cloudId,this.page);
    },
    //搜索框
    loadAll() {
      return [{  }];
    },
    querySearchAsync(queryString, cb) {
      var companys = this.companys;
      var results = queryString
        ? companys.filter(this.createStateFilter(queryString))
        : companys;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      // console.log(item);
    },
    //搜索框
    //侧边栏
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    //退出登录
    quit(){
      //清除userInfo和token，跳转到登录页
      localStorage.removeItem("userInfo")
      localStorage.removeItem("token")
      this.$router.push("/")
    },
    handleCommand(){
      //清除userInfo和token，跳转到登录页
      localStorage.removeItem("userInfo")
      localStorage.removeItem("token")
      this.$router.push("/")
    },
  },
  //搜索框
  created(){
    //下拉选择信息
    this.cloudSelect();
  },
  mounted() {
    this.companys = this.loadAll();
  }
};
</script>

<style scoped>
.home_page {
  width: 100%;
  height: 100%;
}
.bigContainer{
  width: 100%;
  height: 100%;
}

.el-aside {
  background-color: #303070;
  color: #333;
  height: 100%;
  width: 200px;
}
.user{
  width: 16px;
  height: 16px;
  color: #666;
  color: var(--svg-img-bg);

}
.el-menu-vertical-demo{
    width: 100%;
}
.el-menu{
  border: none;
}
.el-menu-vertical-demo .is-active {
   background-color: #5673FF !important;
}
/* aside */
.side_img {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.side_img img {
  width: 70%;
  height: 50%;
}
.side_nav{
    width: 100%;
}
/* 侧边文字 */
.side_nav .el-menu-vertical-demo span{
    display: inline-block;
    width: 75px;
    text-align: justify;
    text-justify:distribute-all-lines; 
    text-align-last:justify;
}

.smallContainer{
  width: calc(100% - 200px);
  height: 100%;
}

/* container */
.el-header{
  background-color: #fff;
  color: #333;
  text-align: center;
  /* height: 7%!important; */
  display: flex;
  align-items: center;
}
.header {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.search {
  height: 100%;
  display: flex;
  align-items: center;
  width: 25%;
}
/* 圆角无效果 */
.search >>> .el-input--prefix .el-input__inner {
  border-radius: 25px !important;
  background: #F4F6FA;
  border: none;
}
.search >>> .el-autocomplete{
  width: 100%;
  height: 50px;
}
/* 高度居中未实现 */
.userinfo {
  height: 100%;
  line-height: 60px !important;
  display: flex;
  align-items: center;
}
.el-avatar {
  background: white;
}
.user_name {
  margin: 0 10px;
}
.quit{
  cursor: pointer;
  color: pink;
}


.el-main {
  background-color:#F7F8FC;
  color: #333;
  width: 100%;
  height: calc(100% - 60px);
}
.main{
  width: 100%;
  height: 100%;
  /* min-height: calc(100vh - 60px); */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.bread_cloud{
  width: 100%;
  height: 60px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.breadcrumb{
  margin-left: 20px;
  margin-right: 30px;
}
.el-submenu .el-menu-item{
  padding-left: 55px!important;
}

</style>


// WEBPACK FOOTER //
// src/pages/Home/index.vue